import { useMemo, useState } from 'react'
import { Button, Image } from "react-bootstrap";
import ReviewOne from '../../../assests/images/review-preview-images/review-preview-1.webp';
import ReviewTwo from '../../../assests/images/review-preview-images/review-preview-2.webp';
import {
  ReviewTitle,
  ReviewStrong,
  ReviewSpan,
  ReviewBox,
  ReviewContent,
  ReviewRole,
  ReviewDonor,
  ClientReview,
  ReviewHelp,
  ReviewHelpLeft,
  ReviewHelpRight,
  ReviewLike,
  ShareSocial,
  ShareSocialList,
  ShareSocialItem,
  ReviewNonprofit,
  ReviewDate,
  DateCol,
  ReviewImage,
  ReviewImageBox,
  NonBtn,
} from './nonprofitReviewsStyle';
import RatingStar from '../ratingStar/ratingStar';
import MailIcon from '../../../assests/images/mail.svg';
import FacebookIcon from '../../../assests/images/facebook.svg';
import TwitterIcon from '../../../assests/images/xicon.svg';
import moment from 'moment';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { MESSAGE } from '../../../utils/message';
import Thumb from '../../../pages/Faq/thumb';
import DisLikeThumb from '../../../pages/Faq/disLikeThumb';
import { useSelector } from 'react-redux';
import UnPublishModal from '../modal/unPublishModal';
import { useDispatch } from 'react-redux';
import { deleteReviewHandler } from '../../../redux/slices/donationCamp/deleteReview-slice';
import { userProfileReviewHandler } from '../../../redux/slices/myAccount/userProfileReview-slice';

interface Props {
  reviewData: any;
  page?: string;
}

const NonprofitReviews = ({ reviewData, page }: Props) => {

  const { user_id } = useParams();
  const [editUnpublishOpen, setEditUnpublishOpen] = useState(false);
  const [isLike, setIsLike] = useState(false)
  const [isDisLike, setIsDisLike] = useState(false)
  const [reviewId, setReviewId] = useState("")
  const dispatch: any = useDispatch();

  const handleLike = () => {
    setIsDisLike(false)
    setIsLike(true)
  }
  const handleDisLike = () => {
    setIsDisLike(true)
    setIsLike(false)
  }
  const navigate = useNavigate()
  const getShareUrl = (platform: string) => {
    const url = "";

    switch (platform) {
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
      case 'twitter':
        return `https://twitter.com/intent/tweet?url=${url}`;
      default:
        return '#';
    }
  };



  const reviewsList = useMemo(() => {
    return (reviewData && Array.isArray(reviewData?.results)) ? reviewData.results : []
  }, [reviewData])


  const handleUnpublish = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    const unpublish = true;

    dispatch(deleteReviewHandler(reviewId, unpublish));
    dispatch(userProfileReviewHandler(user_id));
    setEditUnpublishOpen(false);

  }
  return (
    <>
      {reviewsList.map((review: any, _index: number) => (
        <div key={review?.id} className='review-box'>
          <ReviewTitle className='review-main-title'>
            <ReviewStrong >{review?.status?.toLowerCase() === 'open' ? '' : 'CLOSED'}</ReviewStrong> Review for <Link style={{ textDecoration: "none" }} to={`/org/${review?.nonprofit_slug}`} className=''><ReviewSpan>{review?.nonprofit}, </ReviewSpan></Link>{review?.city}, {review?.state}, USA </ReviewTitle>
          <ReviewBox>
            <ClientReview>
              <ReviewDate>
                <RatingStar review={34} rating={review?.rating} />
                <DateCol className='date-text'>{moment(review?.date).format("MMM D, YYYY")}</DateCol>
              </ReviewDate>
              <ReviewContent>{review?.review}</ReviewContent>
              {page !== 'my-account' &&
                <ReviewImage className="review-uploaded-image">

                  <ReviewImageBox>
                    <Image src={ReviewOne} alt="Review One" />
                  </ReviewImageBox>

                  <ReviewImageBox>
                    <Image src={ReviewTwo} alt="Review Two" />
                  </ReviewImageBox>

                </ReviewImage>
              }
              <ReviewRole>{MESSAGE.role}:</ReviewRole>
              <ReviewDonor> {review?.role}</ReviewDonor>

            </ClientReview>

            <ReviewNonprofit className='review-help'>

              <ReviewHelp>
                <ReviewHelpLeft>
                  <ReviewLike>
                    {MESSAGE.helpful}
                    <Thumb isLike={isLike} handleLike={handleLike} />
                    <DisLikeThumb isDisLike={isDisLike} handleDisLike={handleDisLike} />
                  </ReviewLike>

                </ReviewHelpLeft>
                <ReviewHelpRight>
                  <ShareSocial> {MESSAGE.shareReview}:</ShareSocial>
                  <ShareSocialList>
                    <ShareSocialItem><Button className='social-btn' onClick={() => window.open("mailto:")} > <Image src={MailIcon} /> </Button></ShareSocialItem>
                    <ShareSocialItem><Button className='social-btn' href={getShareUrl('facebook')} target="_blank"> <Image src={FacebookIcon} /> </Button></ShareSocialItem>
                    <ShareSocialItem><Button className='social-btn' href={getShareUrl('twitter')} target="_blank"> <Image src={TwitterIcon} /> </Button></ShareSocialItem>
                  </ShareSocialList>
                </ReviewHelpRight>
              </ReviewHelp>
            </ReviewNonprofit>
            <NonBtn>
              {page === "my-account" && review?.status != 'closed' &&
                <Button className="btn-outline-success-blue btn btn-primary" onClick={() => {
                  setEditUnpublishOpen(true);
                  setReviewId(review?.id)
                }}>{MESSAGE.unPublish}</Button>
              }

              {page === "my-account" && review?.donation_status && <Button className="btn-outline-success-blue" onClick={() => navigate(`/org/${review?.nonprofit_slug}`, { state: { isDonate: true } })}>{MESSAGE.donateThisNonprofit}</Button>}
              {review?.can_create_fundraiser &&
                <Button className="btn-outline-success-blue mx-2" onClick={() => navigate(`fundraisers/create/${review?.id}/${review?.nonprofit_id}`, { state: { org_name: review?.nonprofit } })}>{MESSAGE.createFundRaiser}</Button>
              }
            </NonBtn>
          </ReviewBox>
        </div>
      ))}
      {
        reviewsList?.length === 0 &&
        <>
          No reviews have been written yet.
        </>
      }
      <UnPublishModal editUnpublishOpen={editUnpublishOpen} setEditUnpublishOpen={setEditUnpublishOpen} confirmUnpublish={handleUnpublish} />
    </>
  )
}

export default NonprofitReviews
